import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  CreateApiKeyDto,
  CreateApiKeyResponseDto,
} from '../../../models/api-key/dto/create-api-key.dto';
import { GET_API_KEYS_QUERY_KEY } from './constants';

export const useCreateApiKey = (organizationId: string) => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateApiKeyDto) =>
      client.fetchApi<CreateApiKeyResponseDto, CreateApiKeyDto>({
        endpoint: `organizations/${organizationId}/api-keys`,
        method: 'POST',
        body: input,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_API_KEYS_QUERY_KEY(organizationId),
      });
    },
  });
};
